import { useState } from 'react';
import { motion } from 'framer-motion';

import { data } from './data';
import styles from './faq.module.css';

export const FAQ = () => {
    const [expandedItemIndex, setExpandedItemIndex] = useState(-1);

    const handleToggle = (index: number) => {
        setExpandedItemIndex((v) => (v === index ? -1 : index));
    };

    return (
        <dl className={styles['faq__list']}>
            {data.map((item, index) => (
                <motion.div
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    data-open={expandedItemIndex === index ? 'true' : 'false'}
                    className={styles['faq__item']}
                >
                    <dt className={styles['faq__question']}>
                        <button
                            type="button"
                            onClick={() => handleToggle(index)}
                            className={styles['faq__toggle']}
                        >
                            {item.question}
                        </button>
                    </dt>
                    <motion.dd
                        animate={{
                            opacity: expandedItemIndex === index ? 1 : 0,
                            height: expandedItemIndex === index ? 'auto' : 0,
                            transition: { type: 'tween', duration: 0.3, ease: 'easeInOut' }
                        }}
                        className={styles['faq__answer']}
                    >
                        {item.answer}
                    </motion.dd>
                </motion.div>
            ))}
        </dl>
    );
};
